define ['./builder.scss'], () ->
  ($localStorage, $state, RENTAPPLICATION_API_URL) ->
    restrict: "E"
    template: require("./builder.jade")
    scope:
      url: "="
      id: "="
      onSave: "="
      hostname: "="
    link: (scope, element, attrs) ->
      scope.hostname = window.location.protocol + "//" + scope.hostname
      require.ensure [], () ->
        Freeform = require "freeforms"
        freeform = new Freeform
          urlRoot: scope.url
          id: scope.id
          el: $(element).find(".builder")
          onSave: scope.onSave

        #
        # application.form_model.on 'freeforms.display:done', ->
        #   new ModalSettingsView(model: application.form_model)
        #
        # application.form_model.on 'sync', ->
        #   newslug = application.form_model.get('slug')
        #   # if newslug != undefined
        #     # $state.go "root.applications.customize", {application_template_slug: newslug }, {reload: true}
        #
        # window.application = application



// WEBPACK FOOTER //
// ./directives/freeforms/builder/builder.coffee